import { SwipeableDrawer } from "@mui/material"

function Drawer({children,width="1200px",open,onClose,onOpen}){
    return(<SwipeableDrawer
        PaperProps={{
          sx: {
            height: "100vh",
            margin: 0,
            padding: "20px",
            borderRadius: 0,
            width,
            overflowY: "auto",
          },
        }}
        anchor={"right"}
        open={open}
        onClose={onClose}
        onOpen={onOpen}
      >
        {children}
      </SwipeableDrawer>)

}

export default Drawer